
































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { Item2LinksElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Item2LinksEl',
  components: { ConfirmDialog },
  props: {
    templateItemData: {
      type: Object as () => Item2LinksElInterface,
      required: true
    }
  },
  data: () => ({
    showFirstPopUp: false,
    showSecondPopup: false
  }),
  computed: {
    dividerStyle (): string {
      return 'background: ' + this.templateItemData.colorSeparator + '; height: 20px;'
    },
    hasFirstPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog1')
    },
    hasSecondPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog2')
    }
  }
})
